import { IonButton, IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { useHistory, useLocation, useParams } from 'react-router';
import ViewInterview from '../../components/interview/ViewInterview';
import ViewInterviewV2 from '../../components/interview/ViewInterviewV2';
import WatchInterviews from '../../components/interview/WatchInterviews';
import { CustomRoutes } from '../../utils/CustomRoutes';
import AddQuestion from '../../components/interview/AddQuestion';
import LoginComponent from '../../components/common/LoginComponent';

const WatchInterviewsPage: React.FC = () => {
  const history = useHistory();
  const goToViewInterviews = () => {
    history.push(CustomRoutes.viewInterview);
  }
  let orgPageTitle = "Create Your Own Question"
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>
            {orgPageTitle}
          </IonTitle>
          <IonButtons slot='end'>
            <LoginComponent></LoginComponent>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar color="primary">
            <IonTitle size="large">{orgPageTitle}</IonTitle>
            {/* <IonButton>View Interviews</IonButton> */}
          </IonToolbar>
        </IonHeader>
        <AddQuestion isModel={false}></AddQuestion>
      </IonContent>
    </IonPage>
  );
};

export default WatchInterviewsPage;
